import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganismFhwSearchProps } from '../../../model/global';
import { IPartner } from '../../../model/partner';

type InitalPartnersState = {
	apiUrls: OrganismFhwSearchProps['apiUrls'] | undefined;
	selectedPartnerId: string | undefined;
	focussedPartnerId: IPartner['id'] | undefined;
};

const initialState: InitalPartnersState = {
	selectedPartnerId: undefined,
	apiUrls: undefined,
	focussedPartnerId: undefined,
};

const fhwSlice = createSlice({
	name: 'fhwSlice',
	initialState,
	reducers: {
		setApiUrls(state, { payload }: PayloadAction<OrganismFhwSearchProps['apiUrls']>) {
			state.apiUrls = payload;
		},
		setSelectedPartner(state, { payload }: PayloadAction<string | undefined>) {
			state.selectedPartnerId = payload;
		},
		setFocussedPartnerId(state, { payload }: PayloadAction<IPartner['id'] | undefined>) {
			state.focussedPartnerId = payload;
		},
	},
});

export const fhwSliceActions = fhwSlice.actions;
export default fhwSlice.reducer;
